import type { ConversationResponse } from '@acme/api/admin';
import type { ConversationSection } from '../lib';
import { ConversationListItem } from './conversationlistitem';

export interface ConversationListProps {
  sections: ConversationSection[];
  selectedUserId?: string;
  onSelect: (conversation: ConversationResponse) => void;
}

export const ConversationList = (props: ConversationListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {props.sections.map(({ sectionLabel, items }) => (
        <div key={sectionLabel} className="flex flex-col">
          <div className="px-3 py-2 text-base font-medium text-gray-500">
            {sectionLabel}
          </div>

          <div className="flex flex-col">
            {items.map((conversation) => {
              const userId = conversation.userId ?? '';
              const isSelected =
                Boolean(props.selectedUserId) &&
                userId === props.selectedUserId;

              return (
                <ConversationListItem
                  key={conversation.id || userId}
                  conversation={conversation}
                  isSelected={isSelected}
                  onSelect={props.onSelect}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
